import { instance } from "./api";

export async function createPlantCategory(payload) {
  const formData = new FormData();
  formData.append("Plant_Scientific_Name", payload.Plant_Scientific_Name);
  formData.append("Plant_Eng_Name", payload.Plant_Eng_Name);
  formData.append("Plant_Local_Name", payload.Plant_Local_Name);
  formData.append("Plant_Habit", payload.Plant_Habit);
  formData.append("Plant_Nature", payload.Plant_Nature);
  formData.append("Plantation_Type", payload?.Plantation_Type);
  //   formData.append('Type_Of_Soil', payload.Type_Of_Soil);
  formData.append(
    "Monitoring_Frequency",
    payload.Monitoring_Frequency.toString()
  );
  formData.append("Plant_Desc", payload.Plant_Desc);
  formData.append("Plant_Img", payload.Plant_Img);
  formData.append("Plant_Uses", payload.Plant_Uses);
  formData.append("Plant_Color", payload.Plant_Color);
  formData.append("Plant_Season", payload.Plant_Season);
  formData.append("Plant_Color_Name", payload.Plant_Color_Name);
  const response = await instance.post("admin/addPlant", formData);
  return response.data;
}
export async function updatePlantCategory(payload) {
  const formData = new FormData();
  formData.append("Plant_Scientific_Name", payload.Plant_Scientific_Name);
  formData.append("Plant_Eng_Name", payload.Plant_Eng_Name);
  formData.append("Plant_Local_Name", payload.Plant_Local_Name);
  formData.append("Plant_Habit", payload.Plant_Habit);
  formData.append("Plant_Nature", payload.Plant_Nature);
  formData.append("Plant_Color", payload.Plant_Color);
  formData.append("Plantation_Type", payload.Plantation_Type);
  //   formData.append('Type_Of_Soil', payload.Type_Of_Soil);
  formData.append(
    "Monitoring_Frequency",
    payload.Monitoring_Frequency.toString()
  );
  formData.append("Plant_Desc", payload.Plant_Desc);
  formData.append("Plant_Img", payload.Plant_Img);
  formData.append("Plant_Uses", payload.Plant_Uses);
  formData.append("Plant_Season", payload.Plant_Season);
  formData.append("Plant_Color_Name", payload.Plant_Color_Name);
  formData.append("Is_Active", payload.Is_Active.toString());

  const response = await instance.post(
    `admin/updatePlant/${payload.params}`,
    formData
  );
  return response.data;
}

export async function getPlantsList(payloads) {
  const { results, page, filters } = payloads;

  const applyFilter = filters?.length > 0 ? "&filter=" + filters : "";
  const response = await instance.get(
    `admin/getPlants?limit=${results}&page=${page}${applyFilter}`
  );
  return response.data;
}
export async function getPlants() {
  const response = await instance.get(`admin/getPlants`);
  return response.data;
}

export async function getPlantsByPlotId(payload) {
  const { filter, id } = payload;
  let applyFilter = filter === "" ? "" : `?filter=${filter}`;
  const response = await instance.get(`admin/plantData?plot=${id}${applyFilter}`);
  return response.data;
}

export async function getPlantSuggestions(searchParams) {
  const response = await instance.get(
    `user/searchSerialNo?serialNo=${searchParams}`
  );
  return response.data;
}
export async function getPlantDetails(payloads) {
  const { id, currentPage, pageSize } = payloads;

  const response = await instance.get(
    `user/monitoringDetails?code=${id}&limit=${pageSize}&page=${currentPage}`
  );
  return response.data;
}
export async function getPlantDetailsForAutocomplete(code) {
  const response = await instance.get(`user/monitoringDetails?code=${code}`);
  return response.data;
}

export async function addPlantMonitoring(payload) {
  // Build FormData using Object.entries and reduce
  console.log(payload, "data")
  delete payload["Plant_Location_Name"];
  delete payload["Plant_Plot_Name"];
  delete payload["Plant_Scientific_Name"];
  delete payload["conditionalValidation"];
  const formData = new FormData();

  // Append each key-value pair in the payload to the FormData object
  Object.entries(payload).forEach(([fieldName, fieldValue]) => {
    if (Array.isArray(fieldValue)) {
      // If the field value is an array, assume it's an array of files and append each file separately
      fieldValue.forEach((file) => {
        formData.append(fieldName, file);
      });
    } else {
      // Otherwise, append the field value directly
      formData.append(fieldName, fieldValue);
    }
  });
  // const formData = Object.entries(payload).reduce(
  //   (formData, [fieldName, fieldValue]) => {
  //     formData.append(fieldName, fieldValue);
  //     return formData;
  //   },
  //   new FormData()
  // );
  const response = await instance.post(`user/monitoring`, formData);
  return response.data;
}

export async function updatePlantMonitoring(payload) {
  const { updateId } = payload;
  // Build FormData using Object.entries and reduce
  [
    "Plant_Location_Name",
    "Plant_Plot_Name",
    "Plant_Scientific_Name",
    "Plantation_Monitoring_Type",
    "BarCode_Auto_ID",
    "conditionalValidation",
    "PlantMonitr_Auto_ID",
    "Is_Active",
    "Created_Dt",
    "Created_By",
    "Modified_Dt",
    "Modified_By",
    "updateId",
    "modified_by",
    "created_by",
  ].forEach((item) => delete payload[item]);
  const formData = new FormData();

  // Append each key-value pair in the payload to the FormData object
  Object.entries(payload).forEach(([fieldName, fieldValue]) => {
    if (Array.isArray(fieldValue)) {
      // If the field value is an array, assume it's an array of files and append each file separately
      fieldValue.forEach((file) => {
        formData.append(fieldName, file);
      });
    } else {
      // Otherwise, append the field value directly
      formData.append(fieldName, fieldValue);
    }
  });

  try {
    const response = await instance.post(
      `user/updateMonitoring/${updateId}`,
      formData
    );
    return response.data;
  } catch (error) {
    console.error('Error updating plant monitoring:', error);
    throw error;
  }
}

export async function getPlantCategory(category) {
  const response = await instance.get(`user/category/${category}`);
  return response.data;
}

export async function getMonitoringCategory() {
  const response = await instance.get(`user/categoryMonitoring`);
  return response.data;
}

export async function getPlantDataExport(category) {
  const response = await instance.get(`admin/plantExcelReport?minDate=2023-08-27&maxDate=2024-01-01&page=1`);
  return response.data;
}

export async function updatePlantLocation(payload) {
  const form = new FormData();
  form.append('Latitude', payload.Latitude);
  form.append('Longitude', payload.Longitude);
  form.append('Altitude_meter', payload.Altitude_meter);
  form.append('Location', payload.Location);

  const response = await instance.post(`user/barCodeLocationUpdate/${payload.params}`, form);
  return response;
}

